// extracted by mini-css-extract-plugin
module.exports = {"modal-actions":"style_modal-actions__ftAz2"};